var styleDataHash = "63d4ad67";
const injectCss = () => {
  var css = `.ZtWWG,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}._4zE39,._7VDO3{color:var(--ricos-settings-buttons-text-color,#fff);font-family:var(--ricos-settings-text-font-family,Helvetica Neue,Helvetica,Arial);font-size:16px;width:100%}[dir] ._4zE39,[dir] ._7VDO3{border:1px solid var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));border-radius:var(--ricos-settings-buttons-border-radius,0);cursor:pointer}.Y5WGK._4zE39,.Y5WGK._7VDO3{text-decoration:underline}[dir] .Y5WGK._4zE39,[dir] .Y5WGK._7VDO3{border:none}._6O6dj._4zE39,._6O6dj._7VDO3{color:var(--ricos-fallback-color,#000);width:50px}[dir] ._6O6dj._4zE39,[dir] ._6O6dj._7VDO3{background:transparent;border:none;padding:0}[dir] ._4zE39:disabled,[dir] ._7VDO3:disabled{background-color:var(--ricos-settings-disabled-background-color,rgba(0,0,0,.4))}._7VDO3{color:#fff}[dir] ._7VDO3{background-color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] ._7VDO3:hover:not([disabled]){background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.8)}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] ._7VDO3:hover:not([disabled]){background-color:transparent}}}@container (width < 640px){[dir] ._7VDO3:hover:not([disabled]){background-color:transparent}}._7VDO3:disabled{color:var(--ricos-settings-buttons-text-color,hsla(0,0%,100%,.6))}[dir] ._7VDO3:disabled{border:none;cursor:auto}._4zE39,._7VDO3._6O6dj{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] ._4zE39{background:#fff}._4zE39:active,._4zE39:hover{color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.6)}[dir] ._4zE39:active,[dir] ._4zE39:hover{border-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.6)}._4zE39:disabled{color:rgba(0,0,0,.4)}.QJSaG{font-size:14px;height:32px}.azg2c{height:36px}.HcViK{height:40px}.JNmkg{height:48px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var button_default = {
  "fontElementMap": "ZtWWG",
  "button_secondary": "_4zE39",
  "button_primary": "_7VDO3",
  "borderLess": "Y5WGK",
  "mobile": "_6O6dj",
  "tiny": "QJSaG",
  "small": "azg2c",
  "medium": "HcViK",
  "large": "JNmkg"
};
export {
  button_default as default,
  injectCss
};
//# sourceMappingURL=button-scss.js.map
